import { ThemeProvider } from "@mui/material";
import { Box, styled } from "@mui/system";
import { MatxSuspense } from "app/components";
import useSettings from "app/hooks/useSettings";
import { useEffect, useState } from "react";
import Scrollbar from "react-perfect-scrollbar";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const LayoutContainer = styled(Box)(({ width, secondarysidebar }) => ({
  // height: '100vh',
  // display: 'flex',
  // flexGrow: '1',
  // flexDirection: 'column',
  // verticalAlign: 'top',
  // marginLeft: width,
  // position: 'relative',
  // overflow: 'hidden',
  // transition: 'all 0.3s ease',
  // marginRight: secondarysidebar.open ? 50 : 0,
}));

const StyledScrollBar = styled(Scrollbar)(() => ({
  // height: '100%',
  // position: 'relative',
  // display: 'flex',
  // flexGrow: '1',
  // flexDirection: 'column',
}));

const ContentBox = styled(Box)(() => ({
  // height: '100%',
  // display: 'flex',
  // overflowY: 'auto',
  // overflowX: 'hidden',
  // flexDirection: 'column',
  // justifyContent: 'space-between',
}));

const Base = ({ nonFooter }) => {
  const [isTrue, setIsTrue] = useState(false);
  const location = useLocation();
  const { settings, updateSettings } = useSettings();
  const { layout1Settings, secondarysidebar } = settings;
  const topbarTheme = settings.themes[layout1Settings.topbar.theme];
  const {
    leftSidebar: { mode: sidenavMode, show: showSidenav },
  } = layout1Settings;

  useEffect(() => {
    if (location?.pathname.split("/").length > 0) {
      if (location?.pathname.split("/")[1] === "turf-tab") {
        setIsTrue(false);
      } else {
        setIsTrue(true);
      }
    }
  }, [location?.pathname]);

  return (
    <LayoutContainer>

      <ContentBox>
        <ThemeProvider theme={topbarTheme}>
          <Header />
        </ThemeProvider>


        <Box flexGrow={1} position="relative">
          <MatxSuspense>
            <Outlet />
          </MatxSuspense>
        </Box>

        {(isTrue && !nonFooter && <Footer />)}
      </ContentBox>

    </LayoutContainer>
  );
};

export default Base;
